// Textos dos Parâmetros do DP (01/11/2026), coletados por glob em core/i18n/messages.ts. O
// rótulo, a fonte e o efeito de cada regra vêm do catálogo do servidor, em português.
export default {
  pt: {
    'dp.parametros.titulo': 'Parâmetros',
    'dp.parametros.comoFunciona': 'Cada regra do DP que depende de um valor. Cada alteração vale a partir de uma data e o valor anterior fica no histórico. A competência aberta passa a usar o valor novo na próxima apuração, e a fechada nunca muda.',
    'dp.parametros.alterar': 'Alterar',
    'dp.parametros.alterado': 'Alterado',
    'dp.parametros.deFabrica': 'De fábrica',
    'dp.parametros.semAlteracao': 'Sem alteração',
    'dp.parametros.valeDesde': 'Vale desde {{data}}',
    'dp.parametros.proxima': '{{valor}} a partir de {{data}}',
    'dp.parametros.sim': 'Sim',
    'dp.parametros.nao': 'Não',
    'dp.parametros.valorAtual': 'Valor em vigor',
    'dp.parametros.novoValor': 'Novo valor',
    'dp.parametros.vigencia': 'Vale a partir de',
    'dp.parametros.observacao': 'Observação',
    'dp.parametros.entre': 'De {{minimo}} a {{maximo}}',
    'dp.parametros.aPartirDe': 'A partir de {{minimo}}',
    'dp.parametros.listaAjuda': 'Digite e aperte Enter para acrescentar.',
    'dp.parametros.historico': 'Histórico',
    'dp.parametros.vigente': 'Vigente',
    'dp.parametros.agendada': 'Agendada',
    'dp.parametros.anterior': 'Anterior',
    'dp.parametros.aPartirDoDia': 'A partir de {{data}}',
    'dp.parametros.quem': '{{quem}}, {{quando}}',
    'dp.parametros.deFabricaValor': 'Valor de fábrica: {{valor}}',
    'dp.parametros.voltar': 'Voltar ao anterior',
    'dp.parametros.cancelarAgendada': 'Cancelar',
    'dp.parametros.retirar': 'Retirar',
    'dp.parametros.confirmaTitulo': 'Retirar esta alteração?',
    'dp.parametros.confirmaBotao': 'Retirar',
    'dp.parametros.confirmaVigente': 'O parâmetro volta a valer {{valor}}.',
    'dp.parametros.confirmaOutra': 'A alteração sai do histórico da tela e fica registrada na auditoria.',
    'dp.parametros.grupo.vale_alimentacao': 'Vale-alimentação',
    'dp.parametros.grupo.ponto': 'Assinatura do ponto',
    'dp.parametros.semValor': 'Não configurado',
    'dp.parametros.grupo.bonus': 'Bônus e adicionais',
    'dp.parametros.grupo.folha': 'Conferência da folha',
    'dp.parametros.grupo.ausencias': 'Ausências',
    'dp.parametros.grupo.ferias': 'Férias',
    'dp.parametros.grupo.desligamentos': 'Desligamentos',
    'dp.parametros.grupo.contratacoes': 'Contratações',
    'dp.parametros.grupo.exames': 'Exames',
    'dp.parametros.grupo.toxicologico': 'Toxicológico',
    'dp.parametros.grupo.cnh': 'CNH',
    'dp.parametros.grupo.calendario': 'Prazos e calendário',
    'dp.parametros.grupo.painel': 'Painel do Início',
    'dp.parametros.grupo.arquivos': 'Arquivos',
  },
  en: {
    'dp.parametros.titulo': 'Settings',
    'dp.parametros.comoFunciona': 'Every HR rule that depends on a value. Each change applies from a date and the previous value stays in the history. The open pay period uses the new value on the next calculation, and a closed one never changes.',
    'dp.parametros.alterar': 'Change',
    'dp.parametros.alterado': 'Changed',
    'dp.parametros.deFabrica': 'Default',
    'dp.parametros.semAlteracao': 'No changes',
    'dp.parametros.valeDesde': 'Valid since {{data}}',
    'dp.parametros.proxima': '{{valor}} from {{data}}',
    'dp.parametros.sim': 'Yes',
    'dp.parametros.nao': 'No',
    'dp.parametros.valorAtual': 'Current value',
    'dp.parametros.novoValor': 'New value',
    'dp.parametros.vigencia': 'Valid from',
    'dp.parametros.observacao': 'Note',
    'dp.parametros.entre': 'From {{minimo}} to {{maximo}}',
    'dp.parametros.aPartirDe': 'From {{minimo}}',
    'dp.parametros.listaAjuda': 'Type and press Enter to add.',
    'dp.parametros.historico': 'History',
    'dp.parametros.vigente': 'Current',
    'dp.parametros.agendada': 'Scheduled',
    'dp.parametros.anterior': 'Previous',
    'dp.parametros.aPartirDoDia': 'From {{data}}',
    'dp.parametros.quem': '{{quem}}, {{quando}}',
    'dp.parametros.deFabricaValor': 'Default value: {{valor}}',
    'dp.parametros.voltar': 'Back to previous',
    'dp.parametros.cancelarAgendada': 'Cancel',
    'dp.parametros.retirar': 'Remove',
    'dp.parametros.confirmaTitulo': 'Remove this change?',
    'dp.parametros.confirmaBotao': 'Remove',
    'dp.parametros.confirmaVigente': 'The setting goes back to {{valor}}.',
    'dp.parametros.confirmaOutra': 'The change leaves the history on this screen and stays recorded in the audit trail.',
    'dp.parametros.grupo.vale_alimentacao': 'Food allowance',
    'dp.parametros.grupo.ponto': 'Timesheet signature',
    'dp.parametros.semValor': 'Not configured',
    'dp.parametros.grupo.bonus': 'Bonus and allowances',
    'dp.parametros.grupo.folha': 'Payroll check',
    'dp.parametros.grupo.ausencias': 'Absences',
    'dp.parametros.grupo.ferias': 'Vacations',
    'dp.parametros.grupo.desligamentos': 'Terminations',
    'dp.parametros.grupo.contratacoes': 'Hiring',
    'dp.parametros.grupo.exames': 'Exams',
    'dp.parametros.grupo.toxicologico': 'Drug test',
    'dp.parametros.grupo.cnh': 'Driver license',
    'dp.parametros.grupo.calendario': 'Deadlines and calendar',
    'dp.parametros.grupo.painel': 'Home dashboard',
    'dp.parametros.grupo.arquivos': 'Files',
  },
  es: {
    'dp.parametros.titulo': 'Parámetros',
    'dp.parametros.comoFunciona': 'Cada regla del DP que depende de un valor. Cada cambio vale desde una fecha y el valor anterior queda en el historial. El período abierto usa el valor nuevo en el próximo cálculo, y el cerrado nunca cambia.',
    'dp.parametros.alterar': 'Cambiar',
    'dp.parametros.alterado': 'Cambiado',
    'dp.parametros.deFabrica': 'De fábrica',
    'dp.parametros.semAlteracao': 'Sin cambios',
    'dp.parametros.valeDesde': 'Vale desde {{data}}',
    'dp.parametros.proxima': '{{valor}} desde {{data}}',
    'dp.parametros.sim': 'Sí',
    'dp.parametros.nao': 'No',
    'dp.parametros.valorAtual': 'Valor vigente',
    'dp.parametros.novoValor': 'Nuevo valor',
    'dp.parametros.vigencia': 'Vale desde',
    'dp.parametros.observacao': 'Observación',
    'dp.parametros.entre': 'De {{minimo}} a {{maximo}}',
    'dp.parametros.aPartirDe': 'Desde {{minimo}}',
    'dp.parametros.listaAjuda': 'Escriba y pulse Enter para agregar.',
    'dp.parametros.historico': 'Historial',
    'dp.parametros.vigente': 'Vigente',
    'dp.parametros.agendada': 'Programada',
    'dp.parametros.anterior': 'Anterior',
    'dp.parametros.aPartirDoDia': 'Desde {{data}}',
    'dp.parametros.quem': '{{quem}}, {{quando}}',
    'dp.parametros.deFabricaValor': 'Valor de fábrica: {{valor}}',
    'dp.parametros.voltar': 'Volver al anterior',
    'dp.parametros.cancelarAgendada': 'Cancelar',
    'dp.parametros.retirar': 'Quitar',
    'dp.parametros.confirmaTitulo': '¿Quitar este cambio?',
    'dp.parametros.confirmaBotao': 'Quitar',
    'dp.parametros.confirmaVigente': 'El parámetro vuelve a valer {{valor}}.',
    'dp.parametros.confirmaOutra': 'El cambio sale del historial de la pantalla y queda registrado en la auditoría.',
    'dp.parametros.grupo.vale_alimentacao': 'Vale de alimentación',
    'dp.parametros.grupo.ponto': 'Firma de la hoja de asistencia',
    'dp.parametros.semValor': 'Sin configurar',
    'dp.parametros.grupo.bonus': 'Bono y adicionales',
    'dp.parametros.grupo.folha': 'Verificación de la nómina',
    'dp.parametros.grupo.ausencias': 'Ausencias',
    'dp.parametros.grupo.ferias': 'Vacaciones',
    'dp.parametros.grupo.desligamentos': 'Desvinculaciones',
    'dp.parametros.grupo.contratacoes': 'Contrataciones',
    'dp.parametros.grupo.exames': 'Exámenes',
    'dp.parametros.grupo.toxicologico': 'Toxicológico',
    'dp.parametros.grupo.cnh': 'Licencia de conducir',
    'dp.parametros.grupo.calendario': 'Plazos y calendario',
    'dp.parametros.grupo.painel': 'Panel de inicio',
    'dp.parametros.grupo.arquivos': 'Archivos',
  },
} as const
